import { useEffect, useState } from "react";
import { Dropdown, Form, Modal, OverlayTrigger, Tooltip, Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomToggle from "../../components/dropdowns";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import user01 from "../../assets/images/user/01.jpg";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import * as moment from "moment";
import { getToken } from "../../utils/auth";
import Card from "../../components/Card";
import CarouselN from "react-bootstrap/Carousel";
import icon1 from "../../assets/images/icon/01.png";
import {  useParams } from 'react-router-dom'
import { useLogoLink } from "../../Context/LogoLinkContext";

const PostTemplate = ({ index }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  // useEffect(() => {
  //   if (!getToken()) {
  //     navigate("/auth/sign-in");
  //   }
  // }, []);


  const [content, setContent] = useState(null);
  const [comments, setComments] = useState(null);
  const [show, setShow] = useState(null);
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [like, setLike] = useState(false);
  const [likeCounts, setLikeCounts] = useState(0);
  const [data, setData] = useState("");


  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };
  const renderDescription = (data, index) => {
    const description = data?.description;
    const threshold = 180;

    if (description && description.length > threshold) {
      if (expandedRows[index]) {
        return (
          <div>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "#FF5500",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "block",
              }}
            >
              Show Less...
            </button>
          </div>
        );
      } else {
        return (
          <div>
            <div
              style={{ display: "inline" }}
              dangerouslySetInnerHTML={{
                __html: `${description.slice(0, threshold)}...`,
              }}
            />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "#FF5500",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "inline",
              }}
            >
              Show More...
            </button>
          </div>
        );
      }
    } else {
      return <div dangerouslySetInnerHTML={{ __html: description }} />;
    }
  };

  useEffect(() => {
    if(id){
          handleGetComments();
    }
  }, [id]);
  const handleGetComments = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/post/comment/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response && response.data && response.data.data !== "N/A") {
        setComments(response.data.data);
      } else {
        // Handle error or navigate to login page if invalid token/data
        toast.error("Invalid response or token issue. Please log in again.");
        navigate("/auth/sign-in");
      }
      // setComments(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching Devices", error);
    }
  };
  const handleChange = (e, index) => {
    setContent(e.target.value);
  };

  const handleAddComments = async (e, id) => {
    e.preventDefault();
    try {
      const dataToSent = {
        content: content,
        attachmentLink: "",
      };
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/comment/${id}`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // toast.success(response?.data?.message);
      setContent("");
      handleGetComments(id);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  useEffect(() => {
    if (like) {
      setLikeCounts(data?.likes?.length + 1);
    }
  }, [like]);
  useEffect(() => {
    setLikeCounts(data?.likes?.length);
  }, []);
  const handleAddLikes = async (e, id, flag) => {
    e.preventDefault();
    try {
      const dataToSent = {
        addLike: flag,
      };
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/post/like-status/${id}`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // handleAllPost();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };


  const logoLink = useLogoLink();

 const handlePostDetail = async () => {
  try {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await axios.get(
      `${process.env.REACT_APP_URL}/api/post/${id}`,
      { headers }
    );

    setData(response.data.data.post);
    handleGetComments();
  } catch (error) {
    console.log("Failed Fetching Post Detail", error);
  }
};

  useEffect(() => {
    if (id) {
      handlePostDetail();
    }
  }, [id]);
  const handleLogin = () => {
    navigate(`/auth/sign-in`);
  };
  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>

      <div className="iq-top-navbar">
        <Row className="">
          <Col className="d-flex justify-content-between align-items-center">
            <Link
              to="/"
              className="d-flex align-items-center gap-2 iq-header-logo"
            >
                              <img src={logoLink || "/diridologo.jpg"} alt="logo" style={{ height: "70px", padding:"10px" }} />

              {/* <img src="/Logo.png" alt="logo" style={{ height: "60px" }} /> */}
            </Link>
            {/* <button
              type="submit"
              className="btn btn-primary d-block w-100 mt-0"
              style={{ maxWidth: "100px", marginRight: "15px" }}
              onClick={handleLogin}
            >
              Login
            </button> */}
          </Col>
        </Row>
      </div>
      <div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg={8} className="row  p-0" style={{ margin: "auto" }}>
              <div
                style={{
                  border: "1px solid #d4d4d4",
                  borderRadius: "10px",
                  marginBottom: "20px",
                  background: "#fff",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
{data?.toShow ? (
                <Card.Body>
                  <div className="user-post-data">
                    <div className="d-flex justify-content-between">
                      <div className="me-3">
                        <img
                          className="rounded-circle img-fluid"
                          src={
                            data?.userId?.profileImageLink
                              ? data?.userId?.profileImageLink
                              : "/profile.png"
                          }
                          alt=""
                          style={{ width: "55px", height: "50px" }}
                        />
                      </div>
                      <div className="w-100">
                        <div className="d-flex justify-content-between">
                          <div>
                            <h5
                              className="mb-0 d-inline-block text-primary"
                              style={{ cursor: "pointer" }}
                              // onClick={() => handleNavigateProfile(data)}
                            >
                              {data?.userId?.firstName} {data?.userId?.lastName}
                            </h5>
                            {data?.groupId ? (
                              <span className="mb-0 ps-1 d-inline-block ">
                                (Group:{data?.groupId?.groupName})
                              </span>
                            ) : (
                              <div></div>
                            )}

                            <p
                              className="mb-0 "
                              style={{
                                textTransform: "capitalize",
                                color: "gray",
                              }}
                            >
                              {moment(data?.createdAt).fromNow()}
                            </p>
                          </div>
                          <div
                            className="card-post-toolbar"
                            style={{ display: "flex" }}
                          >
                            {data?.userId?.qrCodeUrl ? (
                              <div>
                                <img
                                  src={data?.userId?.qrCodeUrl}
                                  onClick={() =>
                                    handleQrClick(data?.userId?.qrCodeUrl)
                                  }
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                  }}
                                />
                              </div>
                            ) : (
                              <div></div>
                            )}
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{renderDescription(data, index)}</p>
                  </div>
                  <div className="user-post">
                    <div className="user-post">
                      <CarouselN
                        style={{ maxWidth: "450px", margin: "0 auto" }}
                      >
                        {data?.photos?.map((photo, photoIndex) => (
                          <CarouselN.Item key={photoIndex}>
                            <img
                              className="d-block w-100"
                              src={photo}
                              alt={`post-photo-${photoIndex}`}
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </CarouselN.Item>
                        ))}
                      </CarouselN>
                    </div>
                  </div>
                  <div className="comment-area mt-3">
                    {/* <div className="d-flex justify-content-between align-items-center flex-wrap">
                      <div className="like-block position-relative d-flex align-items-center">
                        <div className="d-flex align-items-center">
                          <div className="like-data">
                            <Dropdown>
                              <div>
                                <img
                                  src={icon1}
                                  className="img-fluid"
                                  alt=""
                                  onClick={(e) => {
                                    handleAddLikes(e, data?._id, true);
                                    setLike(!like);
                                  }}
                                />
                              </div>
                            </Dropdown>
                          </div>
                          <div className="total-like-block ms-2 me-3">
                            <Dropdown>
                              <Dropdown.Toggle
                                as={CustomToggle}
                                id="post-option"
                              >
                                {likeCounts}{" "}
                                {data?.likes?.length > 1 ? "Likes" : "Like"}
                              </Dropdown.Toggle>
                            </Dropdown>
                          </div>
                        </div>
                        <div className="total-comment-block">
                          <Dropdown>
                            <Dropdown.Toggle as={CustomToggle} id="post-option">
                              {comments?.allComments.length} Comments
                            </Dropdown.Toggle>
                          </Dropdown>
                        </div>
                      </div>
                    </div> */}
                    {/* <hr /> */}
                    <ul className="post-comments p-0 m-0">
                      {comments?.allComments?.slice(0, 3).map((i) => (
                        <li className="mb-0">
                          <div className="d-flex">
                            <div className="user-img">
                              <img
                                src={i?.author?.profileImageLink}
                                alt="userimg"
                                className="avatar-35 rounded-circle img-fluid"
                              />
                            </div>
                            <div className="comment-data-block ms-3">
                              <h6>
                                {i?.author?.firstName} {i?.author?.lastName}
                              </h6>
                              <p className="mb-0">{i?.content}</p>
                              <div className="d-flex flex-wrap align-items-center comment-activity">
                                <span> {moment(i?.timestamp).fromNow()} </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                      {show === index &&
                        comments?.allComments
                          ?.slice(3, 10000000000)
                          .map((i) => (
                            <li className="mb-0">
                              <div className="d-flex">
                                <div className="user-img">
                                  <img
                                    src={i?.author?.profileImageLink}
                                    alt="userimg"
                                    className="avatar-35 rounded-circle img-fluid"
                                  />
                                </div>
                                <div className="comment-data-block ms-3">
                                  <h6>
                                    {i?.author?.firstName} {i?.author?.lastName}
                                  </h6>
                                  <p className="mb-0">{i?.content}</p>
                                  <div className="d-flex flex-wrap align-items-center comment-activity">
                                    <span>
                                      {" "}
                                      {moment(i?.timestamp).fromNow()}{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                      <button
                        className=" border-0 "
                        style={{ background: "transparent" }}
                        onClick={() => {
                          setShow(show === index ? null : index);
                        }}
                      >
                        {comments?.allComments?.length > 3 &&
                          (show === index ? "Show Less" : "Show More")}
                      </button>
                    </ul>
                    {/* <form
                      className="comment-text d-flex align-items-center "
                      action=""
                      onSubmit={(e) => handleAddComments(e, data?._id)}
                    >
                      <input
                        type="text"
                        className="form-control rounded"
                        placeholder="Enter Your Comment"
                        value={content}
                        onChange={(e) => handleChange(e)}
                      />
                    </form> */}
                  </div>
                </Card.Body>
                ):(
                <Card.Body>
                  <div style={{textAlign:"center"}}>This post is Private</div>
                </Card.Body>
                )}
                <Modal
                  size="md"
                  className="fade"
                  id="qr-modal"
                  onHide={closeQrPopup}
                  show={qrPopupOpen}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>QR Code</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="text-center">
                    <img
                      src={qrImageUrl}
                      alt="QR Code"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn btn-secondary"
                      onClick={closeQrPopup}
                    >
                      Close
                    </button>
                  </Modal.Footer>
                </Modal>
               
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default PostTemplate;
